import {handlebar}            from "@Common/libs/handlebars/handlebars";
import {handlebarsDateformat} from "@Common/libs/handlebars/handlebars-dateformat";
import {numeralHelper}        from "@Common/libs/handlebars/numeral-helper";
import {he}                   from "@Common/libs/he/he";

import {
    comparisonHelper, strWrap, strReplace, trimStart, deepBind, xdDateFormat, uppercase, lowercase
} from "./handlebar-helpers";

export const getBindingResults = (o, n) => {
    let res = Handlebars.compile(n, { noEscape: true });
    //updated to at least allow the special characters from build3 and bullets
    let result = he.decode(res(o)).replace(/[\u0250-\u2012]|[\u2028-\u206F]|[\u2070-\ue007]/g, '');
    return result;
};


const Handlebars = handlebar.create();
numeralHelper.registerHelpers(Handlebars);
Handlebars.registerHelper("dateFormat", handlebarsDateformat);
Handlebars.registerHelper('ifCond', comparisonHelper);
Handlebars.registerHelper('strWrap', strWrap);
Handlebars.registerHelper('strReplace', strReplace);
Handlebars.registerHelper('deepBind', deepBind);
Handlebars.registerHelper('trimStart', trimStart);
Handlebars.registerHelper('xdDateFormat', xdDateFormat);
Handlebars.registerHelper('uppercase', uppercase);
Handlebars.registerHelper('lowercase', lowercase);
